import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 12.415c-.6 0-1 .391-1 .978v5.18c0 .587-.4.978-1 .978H3c-.6 0-1-.39-1-.977V4.888c0-.587.4-.978 1-.978h5.3c.6 0 1-.39 1-.978 0-.586-.4-.977-1-.977H3c-1.7 0-3 1.27-3 2.933v13.685c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.27 3-2.933v-5.18c0-.587-.4-.978-1-.978m2.7-8.212-4-3.91a.98.98 0 0 0-1.4 0l-10 9.776c-.2.195-.3.39-.3.684v3.91c0 .587.4.978 1 .978h4c.3 0 .5-.098.7-.293l10-9.776a.93.93 0 0 0 0-1.369m-11.1 9.483H8v-2.543l9-8.798 2.6 2.542z"
    }, null, -1)
  ]))]))
}
export default { render: render }